import styled from 'styled-components';
import { Button } from 'reactstrap';

import { MainContainer } from './basic';

const PostSubmitMessage = styled.div`
  font-size: 20px;
`;

const PostSubmit = () => (
  <MainContainer className="flex-column">
    <div className="mx-auto text-center m-3">
      <img
        src="https://images.squarespace-cdn.com/content/v1/573a8bbb9f72664e35ff4438/b40d6607-1252-4ce2-b248-33f6b7415ca2/Propagate+Icon_Light.png"
        alt="Propagate"
        width={150}
        height={150}
        className="d-block mx-auto p-2"
      />

      <PostSubmitMessage className="p-2">
        Thanks! A member of our team will be in touch soon.
      </PostSubmitMessage>

      <a href="https://www.propagateag.com/" className="d-block font-large p-2">
        Propagate Homepage
      </a>

      <Button
        color="link"
        className="font-large p-2"
        onClick={() => {
          window.location.reload();
        }}
      >
        Back
      </Button>
    </div>
  </MainContainer>
);

export default PostSubmit;
